<template>
  <a-breadcrumb>
    <a-breadcrumb-item>
      <a-icon
        v-if="breadList[breadList.length -2] && breadList[breadList.length -2].menuUrl"
        @click.prevent="handleLink(breadList[breadList.length -2].menuUrl)"
        type="left"
        class="m-icon-hover"
      />
      <span v-if="currentBreadList || breadList[breadList.length -1]">{{!currentBreadList ? breadList[breadList.length -1].name : currentBreadList}}</span>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
import { mapState } from "vuex";
import { event, store } from "@ice/stark-data";
import { getSession } from "@/utils/storage";
export default {
  name: "Breadcrumb",
  props: {
    menu: {
      type: Array,
    },
  },
  computed: {
    ...mapState(["subMenu", "activeMenu"]),
    // ...mapState(['subMenu', 'activeMenu', 'currentPath'])
  },
  components: {},
  data () {
    return {
      breadList: [],
      currentBreadList: "",
      currentPath: "",
    };
  },
  watch: {
    $route (to, from) {
      this.currentPath = getSession("currentPath");
      this.breadList = this.setMenu(this.menu, to.path);
      if (to.path.includes("undefined")) {
        event.emit("currentBread", "");
        window.history.pushState({}, "", this.currentPath);
      }
    },
  },
  mounted () {
    this.bulletBreadcrumbData();
    const { path } = this.$route;
    this.breadList = this.setMenu(this.menu, path);
  },
  methods: {
    //根据某一个节点向上匹配所有父节点数据
    setMenu (tree, url) {
      var path = [];
      if (!tree) return [];
      var forFn = function (tree, url) {
        for (var i = 0; i < tree.length; i++) {
          // 存放最后返回的内容
          var data = tree[i];
          path.push(data);
          if (data?.menuUrl === url) return path;
          if (data.children) {
            const findChildren = forFn(data.children, url);
            if (findChildren) return findChildren;
          }
          path.pop();
        }
      };
      forFn(tree, url);
      return path;
    },
    async bulletBreadcrumbData () {
      await event.on("currentBread", this.getBread);
    },
    getBread (value) {
      this.currentBreadList = value;
    },
    handleLink (item) {
      // 特殊处理下面包屑的返回事件，由于有些页面点击时需要弹窗让用户二次确认
      if (event.has("breadCrumb")) {
        event.emit("breadCrumb");
      } else {
        this.$router.back();
      }
      //  window.history.pushState({}, '', item)
    },
  },
};
</script>

<style lang="less" scoped>
.jinmao-breadcrumb {
  font-size: 16px;
  font-weight: 500;
  color: #999999;
  // margin-top: 60px;
  // margin-left: 226px;
  a {
    color: #999999;
  }
  .jinmao-breadcrumb-separator {
    color: #999999;
  }
  > span:last-child {
    color: #333333;
  }
}
.business-breadcrumb-link {
  display: flex;
  align-items: center;
}
i.m-icon-hover.anticon.anticon-left {
  background: transparent;
}
.m-icon-hover {
  width: 24px;
  padding: 5px 0;
  border-radius: 2px;
}
.m-icon-hover:hover {
  background: #f5f5f5;
}
</style>